"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var util_1 = require("util");

var Subscription = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(Subscription, _events_1$EventEmitte);

  function Subscription(type, subscription, params, provider, callback) {
    var _this;

    var subscribeImmediately = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    _classCallCheck(this, Subscription);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Subscription).call(this));
    _this.type = type;
    _this.subscription = subscription;
    _this.params = params;
    _this.provider = provider;
    _this.callback = callback;

    if (subscribeImmediately) {
      _this.subscribe();
    }

    return _this;
  }

  _createClass(Subscription, [{
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.id) {
                  this.unsubscribe();
                }

                _context.prev = 1;

                this.listener = function (params) {
                  return _this2.notificationHandler(params);
                };

                this.provider.on('notification', this.listener);
                _context.next = 6;
                return this.provider.send("".concat(this.type, "_subscribe"), [this.subscription].concat(_toConsumableArray(this.params)));

              case 6:
                this.id = _context.sent;

                if (this.id) {
                  _context.next = 9;
                  break;
                }

                throw new Error("Failed to subscribe to ".concat(this.subscription, "."));

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                this.emit('error', _context.t0, this);

              case 14:
                return _context.abrupt("return", this);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function subscribe() {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "notificationHandler",
    value: function notificationHandler(params) {
      var _this3 = this;

      var subscription = params.subscription,
          result = params.result;

      if (subscription !== this.id) {
        return;
      }

      if (result instanceof Error) {
        this.unsubscribe();
        this.emit('error', result, this);
        return;
      }

      var resultArr = util_1.isArray(result) ? result : [result];
      resultArr.forEach(function (resultItem) {
        _this3.callback(resultItem, _this3);
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.listener) {
        this.provider.removeListener('notification', this.listener);
      }

      if (this.id) {
        this.provider.send("".concat(this.type, "_unsubscribe"), [this.id]);
      }

      this.id = undefined;
      this.listener = undefined;
    }
  }]);

  return Subscription;
}(events_1.EventEmitter);

exports.Subscription = Subscription;